/**
 * Generated card-art asset paths — the single place the public URLs of the
 * pipeline output (public/generated/cards/) live, so the renderer never
 * hard-codes a path inline. Court figures are SUIT-NEUTRAL: one figure per
 * rank, reused across all four suits (the suit is a vector overlay).
 *
 * Produced by `tools/asset-pipeline/src/cards-build.ts` (anchor-then-edit; see
 * CARD-ART-SPIKE.md and manifests/cards-v1.yaml).
 */
import type { Rank } from './model';

interface ArtSet {
  png: string;
  avif: string;
  webp: string;
}

const BASE = '/generated/cards';

function set(slug: string): ArtSet {
  return {
    png: `${BASE}/${slug}.png`,
    avif: `${BASE}/${slug}.avif`,
    webp: `${BASE}/${slug}.webp`,
  };
}

/** Court figure art, keyed by rank (11 = Jack, 12 = Queen, 13 = King). */
export const COURT_ART: Record<11 | 12 | 13, ArtSet> = {
  11: set('court-jack'),
  12: set('court-queen'),
  13: set('court-king'),
};

export const CARD_ART = {
  back: set('card-back'),
};

export function courtArtFor(rank: Rank): ArtSet | null {
  if (rank === 11 || rank === 12 || rank === 13) return COURT_ART[rank];
  return null;
}
